import { Outlet } from "react-router-dom";
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import Bodytop from "../components/bodytop";

const AdminLayout = () => {
  return (
    <>
      <Header />
      <Sidebar />
      <Bodytop />

      <Outlet />
    </>
  );
};

export default AdminLayout;
